<script>
  // # # # # # # # # # # # # #
  //
  //  Video
  //
  // # # # # # # # # # # # # #

  // *** PROPS
  export let url = "";

  // *** VARIABLES
  const id = url.match(/([0-9])\w+/g)[0];
</script>

<style lang="scss">
  @import "../variables.scss";

  iframe {
    max-width: 80%;
    max-height: 80%;
  }
</style>

<iframe
  src="https://player.vimeo.com/video/{id}"
  width="1280"
  height="720"
  title="Complete Works"
  frameborder="0"
  byline="false"
  color="#ffffff"
  allow="autoplay; fullscreen"
  allowfullscreen />
